var map = {
	"./bell-icon.svg": "2527",
	"./special-notice-icon.svg": "dfc0",
	"./special-offer-icon.svg": "9aca",
	"./thumbs-up-icon.svg": "f3ba",
	"./urgent-icon.svg": "dc54",
	"./wellness-icon.svg": "c4a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f602";